import DoneIcon from '@mui/icons-material/Done'
import React from 'react'
import IconButton from './IconButton'

const DoneButton = (props: any) => (
  <IconButton {...props}>
    <DoneIcon fontSize='inherit' />
  </IconButton>
)

export default DoneButton
